export default {
  datepickerValue: {},
  optionsValue: false,
  datepickerSelected: false
}